import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-responsive-modal-content',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  // Layout-transparent: see header component for the rationale. With
  // `display: contents`, the inner mat-dialog-content becomes effectively a
  // direct flex child of the user's dialog component host, so the global
  // `.responsive-modal .mat-mdc-dialog-content { flex: 1 1 auto }` rule
  // actually works.
  styles: [`:host { display: contents; }`],
  template: `
    <mat-dialog-content
      class="!p-0 flex-1 min-h-0 flex flex-col"
      [style.overflow]="scrollable() ? 'auto' : 'hidden'"
    >
      <div [ngClass]="padding()" class="flex-1 min-h-0 flex flex-col">
        <ng-content />
      </div>
    </mat-dialog-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResponsiveModalContentComponent {
  /** Tailwind padding utilities applied to the inner wrapper. Override with
   * an empty string to remove padding entirely (useful when the projected
   * content is a smart-grid that should fill the viewport edge-to-edge).
   *
   * IMPORTANT: bound via [ngClass] (not [class]) so the wrapper's static
   * `flex-1 min-h-0 flex flex-col` chain is preserved even when this is
   * empty — otherwise the flex column collapses and the actions row stops
   * being pinned to the bottom of the dialog. */
  readonly padding = input<string>('p-2 md:p-4');

  /** When true (default), the mat-dialog-content owns vertical scrolling
   * for any overflowing children. When false, the dialog content uses
   * `overflow: hidden` so a child component (e.g. smart-grid with its own
   * internal scrollbar) can handle scroll exclusively. Set to false to
   * avoid nested scrollbars. */
  readonly scrollable = input<boolean>(true);
}
